export default {"src":"/_next/static/media/logo_white.25216647.svg","height":100,"width":330};